import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ModalWindow } from "src/app/core/modal-window";

@Component({
  selector: "app-confirm",
  templateUrl: "./confirm.component.html",
  styleUrls: ["./confirm.component.scss"],
  standalone: false,
})
export class ConfirmComponent extends ModalWindow {
  public dialogRef: MatDialogRef<ConfirmComponent>;
  title = "Are you sure?";
  message = "";
  cancelText = "No";
  acceptText = "Yes";
  showCancel = true;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      message: string;
      cancelText: string;
      acceptText: string;
      showCancel: boolean;
    },
    private sanitizer: DomSanitizer,
  ) {
    super();
    this.title = data.title || "Are you sure?";
    this.message = data.message;
    this.cancelText = data.cancelText || "No";
    this.acceptText = data.acceptText || "Yes";
    this.showCancel = data.showCancel;
  }

  sanitizeMessage(message: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(message);
  }
}
